import type { ReactNode } from 'react';
import { AlertCircle, CheckCircle2, Info, TriangleAlert } from 'lucide-react';
import { cn } from '../utils/cn';

export type AlertVariant = 'info' | 'success' | 'warning' | 'danger';

const map: Record<AlertVariant, { bg: string; icon: ReactNode }> = {
  info: { bg: 'bg-[var(--color-info-light)] text-[var(--color-info)]', icon: <Info className="h-4 w-4" /> },
  success: { bg: 'bg-[var(--color-success-light)] text-[var(--color-success)]', icon: <CheckCircle2 className="h-4 w-4" /> },
  warning: { bg: 'bg-[var(--color-warning-light)] text-[var(--color-warning)]', icon: <TriangleAlert className="h-4 w-4" /> },
  danger: { bg: 'bg-[var(--color-danger-light)] text-[var(--color-danger)]', icon: <AlertCircle className="h-4 w-4" /> },
};

export function Alert({
  variant = 'info',
  title,
  children,
  className,
}: {
  variant?: AlertVariant;
  title?: string;
  children?: ReactNode;
  className?: string;
}) {
  const m = map[variant];
  return (
    <div className={cn('flex items-start gap-2 rounded-md border border-transparent p-3 text-sm', m.bg, className)}>
      <span className="mt-0.5">{m.icon}</span>
      <div className="flex-1">
        {title && <div className="font-semibold">{title}</div>}
        {children && <div className="opacity-90">{children}</div>}
      </div>
    </div>
  );
}

export default Alert;
